/** Holds user global infos. */

import _ from 'lodash'
import Vue from 'vue'

let getUserPropHelper = (prop) => {
  let user = localStorage.getItem('user')
  let v = null
  if (user) {
    v = _.get(JSON.parse(user), prop)
  }
  return v
}

/** initial state */
const state = {
  name: getUserPropHelper('name'),
  username: getUserPropHelper('username'),
  defaultHome: getUserPropHelper('defaultHome'),
  roleIds: getUserPropHelper('roleIds'),
  token: getUserPropHelper('token'),
  rules: getUserPropHelper('rules')
}

/** actions */
const actions = {
}

/** getters */
const getters = {
  getPath: (state) => (subject) => {
    return _.get(_.find(state.rules, { subject: subject }), 'path')
  }
}

/** mutations */
const mutations = {
  login (state, user) {
    state.name = user.name
    state.username = user.username
    state.defaultHome = user.defaultHome
    state.roleIds = user.roleIds
    state.rules = user.rules
    state.token = user.token
    Vue.prototype.$ability.update(user.rules)
    localStorage.setItem('user', JSON.stringify(user))
  },

  logout (state) {
    state.name = ''
    state.username = ''
    state.defaultHome = ''
    state.roleIds = ''
    state.token = ''
    state.rules = []
    Vue.prototype.$ability.update(state.rules)
    localStorage.removeItem('user')
  }
}

/* export for using */
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js